<div class="input-group">
  <input class="form-control" [(ngModel)]="display" readonly placeholder="{{'weekpicker.placeholder'|translate}}" (click)="d.toggle()">
  <input class="datepicker" type="text"
         name="dp"
         ngbDatepicker
         [dayTemplate]="day"
         firstDayOfWeek = 7
         [minDate]="minMaxRange.fromDate"
         [maxDate]="minMaxRange.toDate"
         (dateSelect)="onDateSelection($event)"
         #d="ngbDatepicker">
  <ng-template #day let-date let-focused="focused">
        <span class="btn-light"
              [class.focused]="focused"
              [class.range]="isCurrentRange(date)"
              [class.hover]="isHovered(date)"
              [class.faded]="isInsideCurrent(date)"
              (mouseenter)="onHover(date)"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
  </ng-template>
  <div class="input-group-append">
    <button class="btn btn-outline-secondary cal" (click)="d.toggle()" type="button" [attr.aria-label]="'weekpicker.placeholder'|translate" pTooltip="{{'weekpicker.placeholder'|translate}}" tooltipPosition="right">
      <esp-icon name="calendar"></esp-icon>
    </button>
  </div>
</div>
